/* =========================================
   INDEX PAGE ANIMATIONS
   ========================================= */
document.addEventListener('DOMContentLoaded', async () => {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        let mm = gsap.matchMedia();
        mm.add("(prefers-reduced-motion: no-preference)", () => {

        // Setup Hero Arrow Paths
        const heroArrowPaths = document.querySelectorAll('.hero-actions .crayon-svg path');
        if (heroArrowPaths.length > 0) {
            heroArrowPaths.forEach(path => {
                const len = path.getTotalLength();
                gsap.set(path, { strokeDasharray: len, strokeDashoffset: len, opacity: 0 });
            });
        }

        // 1. HERO SECTION & LOGISTICS BAR (MATCHMEDIA FOR PERFECT WATERFALL)

        mm.add("(min-width: 901px)", () => {
            // Desktop Animation (Text -> Image -> Logistics)
            const heroTl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.8 } });
            
            heroTl.fromTo(['.shapes-inline', '.badge-wrapper'], 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0, stagger: 0.15, delay: 0.1 }
            )
            .fromTo('.hero-content h1', 
                { opacity: 0, y: 30 }, 
                { opacity: 1, y: 0 }, 
                "-=0.6"
            )
            .fromTo('.hero-content p', 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0 }, 
                "-=0.6"
            )
            .fromTo('.hero-actions > *', 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0, stagger: 0.15 }, 
                "-=0.6"
            )
           .fromTo('.hero-image-wrapper', 
                { opacity: 0, x: 30 }, 
                { opacity: 1, x: 0, duration: 1.2, ease: 'power2.out' }, 
                "-=1"
            )
            .fromTo('.logistics-grid',
                { opacity: 0, y: 40 },
                { opacity: 1, y: 0, duration: 1, ease: 'power3.out' },
                "-=0.8"
            )
            .fromTo('.logistics-item', 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0, duration: 0.6, stagger: 0.15, ease: 'power3.out' },
                "-=0.6"
            )
            .to('.hero-actions .arrow-line', { opacity: 1, duration: 0.01 }, 1.0)
            .to('.hero-actions .arrow-line', { strokeDashoffset: 0, duration: 1.2, ease: "power2.out" }, 1.0)
            .to('.hero-actions .arrow-tip', { opacity: 1, duration: 0.01 }, 1.8)
            .to('.hero-actions .arrow-tip', { strokeDashoffset: 0, duration: 0.4, ease: "power2.out" }, 1.8);
        });

        mm.add("(max-width: 900px)", () => {
            // Mobile Animation (Image -> Text -> Logistics)
            const heroTl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.8 } });
            
            heroTl.fromTo('.hero-image-wrapper', 
                { opacity: 0, y: 30 }, 
                { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out', delay: 0.1 }
            )
            .fromTo(['.shapes-inline', '.badge-wrapper'], 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0, stagger: 0.15 },
                "-=0.8"
            )
            .fromTo('.hero-content h1', 
                { opacity: 0, y: 30 }, 
                { opacity: 1, y: 0 }, 
                "-=0.6"
            )
            .fromTo('.hero-content p', 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0 }, 
                "-=0.6"
            )
            .fromTo('.hero-actions > *', 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0, stagger: 0.15 }, 
                "-=0.6"
            )
            .fromTo('.logistics-grid',
                { opacity: 0, y: 40 },
                { opacity: 1, y: 0, duration: 1, ease: 'power3.out' },
                "-=0.6"
            )
            .fromTo('.logistics-item', 
                { opacity: 0, y: 20 }, 
                { opacity: 1, y: 0, duration: 0.6, stagger: 0.15, ease: 'power3.out' },
                "-=0.6"
            )
            .to('.hero-actions .arrow-line', { opacity: 1, duration: 0.01 }, 1.8)
            .to('.hero-actions .arrow-line', { strokeDashoffset: 0, duration: 1.2, ease: "power2.out" }, 1.8)
            .to('.hero-actions .arrow-tip', { opacity: 1, duration: 0.01 }, 2.6)
             .to('.hero-actions .arrow-tip', { strokeDashoffset: 0, duration: 0.4, ease: "power2.out" }, 2.6);
        });

        // --- HERO CAROUSEL (Liquid Worm & Crossfade) ---
        const carousel = document.querySelector('.hero-carousel');
        if (carousel) {
            const slides = carousel.querySelectorAll('.hero-slide');
            const dots = carousel.querySelectorAll('.dot');
            const worm = carousel.querySelector('.liquid-worm');
            let currentSlide = 0;
            let autoPlayTimer;
            const slideDuration = 6500; // 6.5 seconds dwell time
            
           const paginationGroup = carousel.querySelector('.hero-pagination');
            
            // Mathematical position calculator for perfect syncing
            const getWormPosition = (index) => {
                const style = getComputedStyle(paginationGroup);
                const paddingLeft = parseFloat(style.paddingLeft) || 12.8; 
                // Gap is calculated by browser, fallback to 9.6px (0.6rem) just in case
                const gap = parseFloat(style.gap) || 9.6; 
                // Formula: padding + (number of preceding dots * (dot width + gap))
                return paddingLeft + index * (8 + gap); 
            };

            // Initialization
            const initCarousel = () => {
                // Set initial worm size and position mathematically
                gsap.set(worm, { 
                    transformOrigin: 'left center',
                    x: getWormPosition(currentSlide), 
                    scaleX: 1 
                });
                
                // Ensure the active dot is hidden under the worm instantly on load
                dots[currentSlide].style.opacity = '0';
                
                // Trigger Ken Burns on first slide
                const img = slides[currentSlide].querySelector('img');
                if (img) img.classList.add('ken-burns');
            };

            // Wait a fraction to ensure CSS layout is computed
            setTimeout(initCarousel, 50);

            const goToSlide = (index) => {
                if (index === currentSlide) return;
                
                const prevSlide = currentSlide;
                currentSlide = index;
                
                // 1. Update Dot States
                dots[prevSlide].classList.remove('active');
                dots[prevSlide].style.opacity = ''; // Restore inactive opacity
                
                dots[currentSlide].classList.add('active');
                dots[currentSlide].style.opacity = '0'; // Hide underlying dot so worm shows clearly
                
                 // 2. Animate true "Liquid" Worm with a stretch & snap sequence
                const oldX = getWormPosition(prevSlide);
                const newX = getWormPosition(currentSlide);
                const distance = Math.abs(newX - oldX);
                const stretchedWidth = distance + 24; // Stretches exactly to cover the gap
                
                // Clear any ongoing animations if user clicks rapidly
                gsap.killTweensOf(worm);
                const wormTl = gsap.timeline();
                
                if (newX > oldX) {
                    // Moving Right: Front edge stretches out, then tail snaps to catch up
                    wormTl.to(worm, { scaleX: stretchedWidth / 24, duration: 0.25, ease: "power2.in" })
                          .to(worm, { x: newX, scaleX: 1, duration: 0.25, ease: "power2.out" });
                } else {
                    // Moving Left: Front edge stretches left, then tail snaps to catch up
                    wormTl.to(worm, { x: newX, scaleX: stretchedWidth / 24, duration: 0.25, ease: "power2.in" })
                          .to(worm, { scaleX: 1, duration: 0.25, ease: "power2.out" });
                }
                
                // 3. Setup Next Slide instantly
                const oldSlide = slides[prevSlide];
                const newSlide = slides[currentSlide];
                const oldImg = oldSlide.querySelector('img');
                const newImg = newSlide.querySelector('img');
                
                // Kill any ongoing tweens if user is spam-clicking dots rapidly
                gsap.killTweensOf([oldSlide, newSlide]);

                newSlide.classList.add('active');
                
                // Force a browser reflow to restart the Ken Burns CSS transition from 0
                if (newImg) {
                    void newImg.offsetWidth; 
                    newImg.classList.add('ken-burns');
                }

                // 4. Crossfade Slides smoothly
                // Use fromTo on newSlide so it doesn't flash 100% opacity from the .active CSS class
                gsap.fromTo(newSlide, { opacity: 0 }, { opacity: 1, duration: 1.2, zIndex: 2, ease: "power2.inOut" });
                
                // Fade out old slide, then clean up its classes ONLY after it is fully invisible
                gsap.to(oldSlide, { 
                    opacity: 0, 
                    duration: 1.2, 
                    zIndex: 1, 
                    ease: "power2.inOut",
                    onComplete: () => {
                        oldSlide.classList.remove('active');
                        if (oldImg) oldImg.classList.remove('ken-burns');
                    }
                });
            };

            const startAutoplay = () => {
                clearInterval(autoPlayTimer);
                autoPlayTimer = setInterval(() => {
                    goToSlide((currentSlide + 1) % slides.length);
                }, slideDuration);
            };

            // Manual Navigation
            dots.forEach((dot, index) => {
                dot.addEventListener('click', () => {
                    goToSlide(index);
                    startAutoplay(); // Reset timer so it doesn't change immediately after a click
                });
            });

            startAutoplay();
            
             // Recalculate worm position on window resize to prevent alignment bugs
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    gsap.set(worm, { 
                        x: getWormPosition(currentSlide), 
                        scaleX: 1 
                    });
                }, 150);
            });
        }

        // USP Cards
        if (document.querySelector('.usp-grid')) {
            gsap.timeline({
                scrollTrigger: { trigger: '.usp-grid', start: 'top 90%' }
            }).fromTo('.usp-card', 
                { opacity: 0, y: 45 },
                { opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out' }
            );
        }

        // Gallery Grid (Slight scale pop for images)
        if (document.querySelector('.gallery-grid')) {
            gsap.timeline({
                scrollTrigger: { trigger: '.gallery-grid', start: 'top 85%' }
            }).fromTo('.gallery-item', 
                { opacity: 0, y: 40, scale: 0.95 },
                { opacity: 1, y: 0, scale: 1, duration: 0.8, stagger: 0.15, ease: 'power3.out' }
            );
        }

      // Overlay Nav Blocks Reveal
        if (document.querySelector('.nav-blocks-wrapper')) {
            const navTl = gsap.timeline({
                scrollTrigger: { trigger: '.nav-blocks-wrapper', start: 'top 85%' }
            });
            
            // 1. Reveal the main wrapper (the outside photo card)
            navTl.fromTo('.nav-blocks-wrapper', 
                { opacity: 0, y: 40 },
                { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }
            )
            // 2. Stagger in the circles slightly before the wrapper finishes fading in
            .fromTo('.nav-block-item', 
                { opacity: 0, y: 30, scale: 0.9 },
                { opacity: 1, y: 0, scale: 1, duration: 0.6, stagger: 0.1, ease: 'back.out(1.5)' },
                "-=0.4"
            );
        }

        }); // End matchMedia
    }

    /* =========================================
       NATIVE SCROLL TESTIMONIAL TRACK & MODAL
       ========================================= */
    const container = document.getElementById('cards-container');
    const prevBtn = document.querySelector('.prev-btn');
    const nextBtn = document.querySelector('.next-btn');
    const modal = document.getElementById('review-modal');
    
    if (!container || !modal) return;

    // Modal elements
    const modalQuote = document.getElementById('modal-quote');
    const closeModalBtn = document.querySelector('.close-modal-btn');

    // Attach logic to the hardcoded DOM cards
    const cards = container.querySelectorAll('.feature-card');
    
    cards.forEach((card) => {
        // Get the quote text for the modal
        const quoteText = card.querySelector('.feature-quote').textContent;

        // Open Modal Logic
        const openModal = () => {
            let splitPoint = quoteText.length;
            
            const quoteContent = card.querySelector('.quote-content');
            const btnContainer = card.querySelector('.dynamic-btn-container');
            
            // Smart Truncation Calculation
            if (btnContainer && btnContainer.innerHTML.includes('button')) {
                const clone = quoteContent.cloneNode(true);
                clone.style.position = 'absolute';
                clone.style.visibility = 'hidden';
                clone.style.webkitLineClamp = 'none';
                clone.style.height = 'auto';
                clone.style.maxHeight = 'none';
                clone.style.width = quoteContent.clientWidth + 'px';
                clone.style.zIndex = '-1';
                
                card.appendChild(clone);
                
                const p = clone.querySelector('.feature-quote');
                const targetHeight = quoteContent.offsetHeight;
                
                let low = 0;
                let high = quoteText.length;
                
                // Binary search to find exact pixel cut-off
                while (low <= high) {
                    let mid = Math.floor((low + high) / 2);
                    p.textContent = '"' + quoteText.substring(0, mid) + '…"';
                    
                    if (clone.offsetHeight <= targetHeight + 2) {
                        splitPoint = mid;
                        low = mid + 1; 
                    } else {
                        high = mid - 1; 
                    }
                }
                
                card.removeChild(clone);
                
                // Backtrack to the last space to avoid cutting words in half
                const lastSpace = quoteText.lastIndexOf(' ', splitPoint);
                if (lastSpace !== -1 && (splitPoint - lastSpace) < 20) {
                    splitPoint = lastSpace;
                }
                
                // Roll forward past trailing punctuation
                while (splitPoint < quoteText.length && /^[^a-zA-Z0-9]$/.test(quoteText[splitPoint])) {
                    splitPoint++;
                }
            }

            // Inject the spans if truncation occurred
            if (splitPoint < quoteText.length && btnContainer && btnContainer.innerHTML.includes('button')) {
                const readPart = quoteText.substring(0, splitPoint);
                const unreadPart = quoteText.substring(splitPoint);
                modalQuote.innerHTML = `"<span class="text-read">${readPart}</span><span class="text-unread">${unreadPart}</span>"`;
            } else {
                modalQuote.innerHTML = `"<span class="text-unread">${quoteText}</span>"`;
            }
            
            // Prevent body scroll and layout jump
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            document.body.style.overflow = 'hidden';
            
            modal.style.display = 'flex';
            void modal.offsetWidth; // Force reflow
            
            modal.classList.add('active');
            modal.setAttribute('aria-hidden', 'false');
        };

        // Smart Truncation Detection
        const quoteContent = card.querySelector('.quote-content');
        const btnContainer = card.querySelector('.dynamic-btn-container');
        
        const checkTruncation = () => {
            if (quoteContent.scrollHeight > quoteContent.clientHeight) {
                if (!btnContainer.innerHTML.includes('button')) {
                    // Inject a visually hidden button covering the whole card for keyboard access
                    btnContainer.innerHTML = '<button class="read-more-btn" aria-label="Read full review"><span class="read-more-content">Read full review</span><span style="position: absolute; inset: 0; z-index: 2;"></span></button>';
                    const hiddenBtn = btnContainer.querySelector('button');
                    hiddenBtn.addEventListener('click', openModal);
                    card.style.cursor = 'pointer';
                    // Ensure the card itself is relatively positioned to contain the absolute button
                    card.style.position = 'relative';
                }
            } else {
                if (btnContainer.innerHTML.includes('button')) {
                    btnContainer.innerHTML = '';
                    card.style.cursor = 'default';
                }
            }
        };

        // Check initially and on resize
        checkTruncation();
        const resizeObserver = new ResizeObserver(checkTruncation);
        resizeObserver.observe(quoteContent);
    });

    // Animate reviews waterfall in ON SCROLL
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        let mm2 = gsap.matchMedia();
        mm2.add("(prefers-reduced-motion: no-preference)", () => {
            gsap.fromTo('.feature-card', 
                { opacity: 0, y: 30 }, // Changed from x to y to prevent horizontal overflow jumping
                { 
                    opacity: 1, 
                    y: 0, 
                    duration: 0.8, 
                    stagger: 0.15, 
                    delay: 0.4, // Wait for the "Loved by Anytown" header text to fade in first
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: '.slider-track-container',
                        start: 'top 85%'
                    }
                }
            );
            
            // Also animate the controls fading in
            gsap.fromTo('.track-controls',
                { opacity: 0, y: 20 },
                {
                    opacity: 1, y: 0, duration: 0.6, delay: 0.5, ease: 'power2.out',
                    scrollTrigger: { trigger: '.slider-track-container', start: 'top 85%' }
                }
            );
        });
    }

    // Close Modal Logic
    const closeModal = () => {
        modal.classList.remove('active');
        modal.setAttribute('aria-hidden', 'true');
        
        setTimeout(() => {
            modal.style.display = 'none';
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }, 400); 
    };

    if (closeModalBtn) closeModalBtn.addEventListener('click', closeModal);
    
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            closeModal();
        }
    });
    
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
            closeModal();
        }
    });
    if (prevBtn && nextBtn && typeof gsap !== 'undefined') {
        let targetIndex = 0; 

        const handleScroll = (direction) => {
            const cards = container.querySelectorAll('.feature-card');
            if (!cards.length) return;
            
            // 1. Sync index with manual swiping by finding the card closest to the exact center of the screen
            const containerCenter = container.scrollLeft + container.clientWidth / 2;
            let closestIndex = 0;
            let closestDist = Infinity;
            
            cards.forEach((card, index) => {
                const cardCenter = card.offsetLeft + card.clientWidth / 2;
                const dist = Math.abs(cardCenter - containerCenter);
                if (dist < closestDist) {
                    closestDist = dist;
                    closestIndex = index;
                }
            });

            // 2. Only update the target if we aren't currently rapid-clicking
            if (!gsap.isTweening(container)) {
                targetIndex = closestIndex;
            }

            // 3. Increment/Decrement
            if (direction === 'next') {
                targetIndex = Math.min(targetIndex + 1, cards.length - 1);
            } else {
                targetIndex = Math.max(targetIndex - 1, 0);
            }

            // 4. Calculate EXACT scroll position to perfectly center the target card
            const targetCard = cards[targetIndex];
            const targetScroll = targetCard.offsetLeft - container.clientWidth / 2 + targetCard.clientWidth / 2;

            container.style.scrollBehavior = 'auto';
            container.style.scrollSnapType = 'none';
            
            gsap.to(container, {
                scrollLeft: targetScroll,
                duration: 0.5,
                ease: "power2.out",
                overwrite: "auto",
                onComplete: () => {
                    // Because we hit the exact pixel center, turning snap back on causes zero glitching!
                    container.style.scrollBehavior = 'smooth';
                    container.style.scrollSnapType = 'x mandatory';
                }
            });
        };

        nextBtn.addEventListener('click', () => handleScroll('next'));
        prevBtn.addEventListener('click', () => handleScroll('prev'));
    }
});
